import { Col } from 'antd';
import styled from 'styled-components';
import { Text } from '@/components/Typography';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const Container = styled(Col)`
	background-color: #eaeefd;
	border-radius: 24px;
	padding: 20px 30px;
	&:hover {
		cursor: pointer;
	}
`;

export const IconWrapper = styled(Col)`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 25px;
	border-radius: 30px;
	padding: 8px 15px;
	color: #ffffff;
	background-color: ${DEFAULT_RISK_RPN_COLOR};
`;

export const CustomText = styled(Text)`
	font-size: 1.2rem;
	text-align: center;
	color: ${DEFAULT_RISK_RPN_COLOR};
	font-weight: 600;
`;
